import { useState } from 'react';
import styled from 'styled-components';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const MainContainer = styled.div`
    padding: 8px 16px;
    box-sizing: border-box;
`;

const ListContainer = styled.div`
    max-height: calc(100% - 148px);
    overflow-y: auto;
    border: 1px solid rgba(0, 0, 0, 0.04);
`;
const AddButton = styled(Fab)`
    margin-top: 24px;
`;

const GamesPanel = ({
    className,
    games,
    selectedGame,
    setSelectedGame,
    configs,
    addGame,
}) => {
    const [newGameMenuAnchorEl, setNewGameMenuAnchorEl] = useState(null);
    const newGameMenuOpen = Boolean(newGameMenuAnchorEl);

    const addGameButtonClick = (event) => {
        setNewGameMenuAnchorEl(event.currentTarget);
    };
    const closeNewGameMenu = () => {
        setNewGameMenuAnchorEl(null);
    };

    const getHandleClickMenuItem = (key) => () => {
        addGame(key);
        closeNewGameMenu();
    };

    return (
        <MainContainer className={className}>
            <h3>Games</h3>
            <ListContainer>
                <List>
                    {games.map((game) => (
                        <ListItem
                            key={game.key}
                            button
                            onClick={() => setSelectedGame(game.name)}
                            selected={
                                selectedGame && selectedGame === game.name
                            }
                            disabled={!setSelectedGame}
                        >
                            <ListItemText primary={game.name} />
                        </ListItem>
                    ))}
                </List>
            </ListContainer>
            <AddButton
                aria-label="Add game"
                color="primary"
                onClick={(e) => {
                    addGameButtonClick(e);
                }}
                disabled={!addGame}
            >
                <AddIcon />
            </AddButton>
            <Menu
                anchorEl={newGameMenuAnchorEl}
                open={newGameMenuOpen}
                onClose={closeNewGameMenu}
            >
                {configs.map((option) => {
                    return (
                        <MenuItem
                            key={option.value}
                            onClick={getHandleClickMenuItem(option.value)}
                        >
                            {option.label}
                        </MenuItem>
                    );
                })}
            </Menu>
        </MainContainer>
    );
};
export default GamesPanel;
